import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-detail-table-row',
    templateUrl: 'detail-table-row.component.html',
    styleUrls: ['./detail-table-row.component.scss'],
    standalone: false,
})
export class DetailTableRowComponent {
}
